<template>
  <v-flex xs12 sm8 md4>
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title
        v-if="forgotParams === ''">Login Form</v-toolbar-title>
         <v-toolbar-title v-else>Forgotten Password</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-if="forgotParams === ''">
        <v-form ref="form-1" lazy-validation>
          <v-text-field
          v-model="user.email"
          :rules="emailRules"
          prepend-icon="person"
          name="login"
          label="Login"
          required
          validate-on-blur
          type="text">
          </v-text-field>
          <v-text-field
          v-model="user.password"
          :rules="passwordRules"
          prepend-icon="lock"
          name="password"
          label="Password"
          id="password"
          validate-on-blur
          :append-icon="show1 ? 'visibility_off' : 'visibility'"
          :type="show1 ? 'text' : 'password'"
           @click:append="show1 = !show1"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-text v-if="forgotParams !== ''">
        <v-form ref="form-3" lazy-validation>
          <v-text-field
          v-model="user.email"
          :rules="emailRules"
          prepend-icon="person"
          name="login"
          label="Login"
          required
          validate-on-blur
          type="text">
          </v-text-field>
          <v-text-field
          v-model="newPassword"
          :rules="passwordRules"
          prepend-icon="lock"
          name="password"
          label="Password"
          validate-on-blur
          id="password1"
          :append-icon="show2 ? 'visibility_off' : 'visibility'"
          :type="show2 ? 'text' : 'password'"
           @click:append="show2 = !show2"
          >
          </v-text-field>
          <v-text-field
          v-model="passwordCheck"
          :rules="passwordCheckRules"
          prepend-icon="lock"
          name="password"
          validate-on-blur
          label="Password"
          id="password2"
          :append-icon="show3 ? 'visibility_off' : 'visibility'"
          :type="show3 ? 'text' : 'password'"
           @click:append="show3 = !show3"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-card-text
        v-if="forgotParams === ''"
        @click="goToReset()"
        @keyup.enter="goToReset()"
        role="button">Forgot your password?</v-card-text>
        <v-spacer></v-spacer>
        <v-btn
        v-if="forgotParams === ''"
         color="primary"
         @click="login($event)">Login</v-btn>
        <v-btn
         v-if="forgotParams !== ''"
         color="primary" @click="reset()">RESET</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>
<script>
import LoginFunctions from '../controllers/Login';

// /**
//  * Define the email pattern to check for valid emails.
//  * @var {regex}
//  * @memberof Login
//  */
// const emailPattern = /^.+@.+\..+$/;

export default {
  name: 'LoginLogin',
  // data: () => ({
  data() {
    return {
      drawer: null,
      step1: true,
      emailSent: false,
      user: {
        email: '',
        password: '',
      },
      newPassword: '',
      passwordCheck: '',
      forgotParams: '',
      show1: false,
      show2: false,
      show3: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be more than 8 characters',
      ],
      passwordCheckRules: [
        v => !!v || 'Password is required',
        v => v === this.newPassword || 'Passwords must match',
      ],
    };
  },
  props: {
    source: String,
  },
  created() {
    // const { pathname } = window.location;
    // this.forgotParams = pathname.split('/').pop();
  },
  mounted() {
  },
  methods: {
    /**
    * To go to reset form.
    * @function
    * @returns {undefined}
    */
    goToReset() {
      this.$router.push('forgot-password');
    },
    /**
    * To prompt the backend call that logs the user in.
    * @function
    * @param {object} event - The click event that prompted this function.
    * @returns {object} A promise that will either return an error message
    * or display the success screen
    */
    login() {
      if (this.$refs['form-1'].validate()) {
        LoginFunctions.login(this.user.email, this.user.password)
          .then((response) => {
            const data = { token: response.data.payload.token };
            this.$store.dispatch('SET_STORAGE_TOKEN', data);
          })
          .then(() => {
            const data = { reset: false };
            this.$store.dispatch('SET_RESET_PASSWORD', data);
            this.$router.push('/home');
          })
          .catch((reason) => {
            console.log(reason);
            this.$emit('snackbar', 'Sorry, try again');
          });
      } else {
        this.$emit('snackbar', 'Sorry, try again');
      }
    },
    /**
    * To prompt the backend call that resets password.
    * @function
    * @param {object} event - The click event that prompted this function.
    * @returns {object} A promise that will either return an error message or
    * display the success screen
    */
    reset() {
      const loginVue = this;
      return loginVue
        .validateResetData()
        .then(() => {
          LoginFunctions.reset(loginVue.newPassword, loginVue.passwordCheck, loginVue.forgotParams)
            .then(() => {
              this.$forceUpdate();
            })
            .then(() => {
              LoginFunctions.login(loginVue.user.email, loginVue.newPassword).then((res) => {
                const data = { token: res.data.payload.token };
                this.$store.dispatch('SET_STORAGE_TOKEN', data);
              }).then(() => {
                this.$router.push('/home');
              }).catch((err) => {
                console.log(err);
                this.$emit('snackbar', 'Sorry, try again');
              });
            })
            .catch((reason) => {
              console.log(reason);
              this.$emit('snackbar', 'Sorry, try again');
            });
        }).catch((err) => {
          console.log(err);
          this.$emit('snackbar', 'Sorry, try again');
        });
    },
  },
};
</script>
<style></style>
